/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_StaffInputs */

const th_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมงานผู้ฝึกสอน`)
};

const en_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching staff`)
};

const ja_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチングスタッフ`)
};

const zh_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教练组`)
};

const es_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo técnico`)
};

const pt_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comissão técnica`)
};

const id_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staf pelatih`)
};

const fr_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staff technique`)
};

const tl_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching staff`)
};

const vi_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ban huấn luyện`)
};

const ko_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코칭스태프`)
};

const de_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainerstab`)
};

const ru_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренерский штаб`)
};

const tr_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknik ekip`)
};

const it_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staff tecnico`)
};

const pl_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sztab szkoleniowy`)
};

const uk_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренерський штаб`)
};

const hi_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोचिंग स्टाफ़`)
};

const ar_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجهاز الفني`)
};

const ms_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kakitangan kejurulatihan`)
};

const bn_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোচিং স্টাফ`)
};

const zh_tw2_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教練團`)
};

const zh_hk2_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教練團`)
};

const ur_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوچنگ اسٹاف`)
};

const fa_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کادر فنی`)
};

const sw_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wakufunzi`)
};

const nl_coaching_staff = /** @type {(inputs: Coaching_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische staf`)
};

/**
* | output |
* | --- |
* | "Coaching staff" |
*
* @param {Coaching_StaffInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const coaching_staff = /** @type {((inputs?: Coaching_StaffInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_StaffInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_coaching_staff(inputs)
	if (locale === "ja") return ja_coaching_staff(inputs)
	if (locale === "zh") return zh_coaching_staff(inputs)
	if (locale === "es") return es_coaching_staff(inputs)
	if (locale === "pt") return pt_coaching_staff(inputs)
	if (locale === "id") return id_coaching_staff(inputs)
	if (locale === "fr") return fr_coaching_staff(inputs)
	if (locale === "tl") return tl_coaching_staff(inputs)
	if (locale === "vi") return vi_coaching_staff(inputs)
	if (locale === "ko") return ko_coaching_staff(inputs)
	if (locale === "de") return de_coaching_staff(inputs)
	if (locale === "ru") return ru_coaching_staff(inputs)
	if (locale === "tr") return tr_coaching_staff(inputs)
	if (locale === "it") return it_coaching_staff(inputs)
	if (locale === "pl") return pl_coaching_staff(inputs)
	if (locale === "uk") return uk_coaching_staff(inputs)
	if (locale === "hi") return hi_coaching_staff(inputs)
	if (locale === "ar") return ar_coaching_staff(inputs)
	if (locale === "ms") return ms_coaching_staff(inputs)
	if (locale === "bn") return bn_coaching_staff(inputs)
	if (locale === "zh-TW") return zh_tw2_coaching_staff(inputs)
	if (locale === "zh-HK") return zh_hk2_coaching_staff(inputs)
	if (locale === "ur") return ur_coaching_staff(inputs)
	if (locale === "fa") return fa_coaching_staff(inputs)
	if (locale === "sw") return sw_coaching_staff(inputs)
	if (locale === "nl") return nl_coaching_staff(inputs)
	return en_coaching_staff(inputs)
});